import {useTranslation} from 'react-i18next';

import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import {Typography, Button, Grid, Icon} from '@mui/material';

import {greenColors, orangeColors} from '../../../../../../layouts/theme/designSystem';
import {MatchStatus} from '../../../../../../types/MatchStatus/MatchStatus';
import {MatchTotalCountPerStatus} from '../../../../../../types/shared-recruiting-types';
interface StatusFilterProps {
  selected: string;
  handleSelected: (selected: string) => void;
  totalCountPerStatus: MatchTotalCountPerStatus;
}

export default function StatusFilter({handleSelected, selected, totalCountPerStatus}: StatusFilterProps) {
  const {t} = useTranslation();

  const counterButtonStyle = {
    textTransform: 'none',
    backgroundColor: 'none',
    '&:hover': {
      backgroundColor: 'transparent',
    },
  };

  const applyConditionalStylesOnSelected = (value: string) => {
    return {
      color: selected === value ? orangeColors[100] : greenColors[100],
    };
  };

  return (
    <Grid
      container
      sx={{
        display: 'flex',
        marginTop: '10px',
        marginLeft: {xs: '0px', md: '12px'},
      }}
    >
      <Grid
        item
        xs={12}
        sx={{
          display: 'flex',
          flexWrap: 'nowrap',
        }}
      >
        <Button onClick={() => handleSelected(MatchStatus.Accepted)} variant='text' sx={counterButtonStyle}>
          <Typography
            variant='h4'
            sx={{
              paddingRight: '4px',
              ...applyConditionalStylesOnSelected(MatchStatus.Accepted),
            }}
          >
            {totalCountPerStatus.accepted || 0}
          </Typography>
          <Typography
            variant='body1'
            sx={{
              ...applyConditionalStylesOnSelected(MatchStatus.Accepted),
            }}
          >
            {t('companyInbox.inboxPageHeader.new')}
          </Typography>

          <Icon
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'start',
            }}
          >
            <KeyboardArrowRightIcon
              fontSize='small'
              sx={{
                transform: selected === MatchStatus.Accepted ? 'rotate(90deg)' : 'rotate(0)',
                ...applyConditionalStylesOnSelected(MatchStatus.Accepted),
              }}
            />
          </Icon>
        </Button>
        <Button onClick={() => handleSelected(MatchStatus.Contacted)} variant='text' sx={counterButtonStyle}>
          <Typography
            variant='h4'
            sx={{
              paddingRight: '4px',
              ...applyConditionalStylesOnSelected(MatchStatus.Contacted),
            }}
          >
            {totalCountPerStatus.contacted || 0}
          </Typography>
          <Typography
            variant='body1'
            sx={{
              ...applyConditionalStylesOnSelected(MatchStatus.Contacted),
            }}
          >
            {t('companyInbox.inboxPageHeader.contacted')}
          </Typography>
          <Icon
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'start',
            }}
          >
            <KeyboardArrowRightIcon
              fontSize='small'
              sx={{
                transform: selected === MatchStatus.Contacted ? 'rotate(90deg)' : 'rotate(0)',
                ...applyConditionalStylesOnSelected(MatchStatus.Contacted),
              }}
            />
          </Icon>
        </Button>
        <Button onClick={() => handleSelected(MatchStatus.Interview)} variant='text' sx={counterButtonStyle}>
          <Typography
            variant='h4'
            sx={{
              paddingRight: '4px',
              ...applyConditionalStylesOnSelected(MatchStatus.Interview),
            }}
          >
            {totalCountPerStatus.interview || 0}
          </Typography>
          <Typography
            variant='body1'
            sx={{
              ...applyConditionalStylesOnSelected(MatchStatus.Interview),
            }}
          >
            {t('companyInbox.inboxPageHeader.interview')}
          </Typography>
          <Icon
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'start',
            }}
          >
            <KeyboardArrowRightIcon
              fontSize='small'
              sx={{
                transform: selected === MatchStatus.Interview ? 'rotate(90deg)' : 'rotate(0)',
                ...applyConditionalStylesOnSelected(MatchStatus.Interview),
              }}
            />
          </Icon>
        </Button>
      </Grid>
    </Grid>
  );
}
